import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-100 border-t border-slate-200 mt-32">

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">

        <div className="grid md:grid-cols-3 gap-16">

          {/* Identity */}
          <div>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">
              Peter <span className="text-blue-600">Magaga</span>
            </h3>

            <p className="text-slate-600 leading-relaxed max-w-sm">
              Backend Engineer focused on building scalable systems,
              clean architectures, and resilient APIs.
            </p>

            <p className="text-slate-500 text-sm mt-6">
              Based in Kenya
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-500 mb-6">
              Navigation
            </h4>

            <ul className="space-y-4 text-slate-600">
              <li>
                <Link to="/" className="hover:text-blue-600 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-blue-600 transition">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-blue-600 transition">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-600 transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-500 mb-6">
              Connect
            </h4>

            <ul className="space-y-4 text-slate-600">
              <li>
                <a
                  href="mailto:ptrmagaga@gmail.com"
                  className="hover:text-blue-600 transition"
                >
                  ptrmagaga@gmail.com
                </a>
              </li>

              <li>
                <a
                  href="https://github.com/petermagaga"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition"
                >
                  GitHub
                </a>
              </li>

              <li>
                <a
                  href="https://linkedin.com/in/petermagaga"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-blue-600 transition"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

        </div>

      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-200 py-8">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500 gap-4">

          <p>
            © {new Date().getFullYear()} Peter Magaga. All rights reserved.
          </p>

          <p>
            Built by petermagaga
          </p>

        </div>
      </div>

    </footer>
  );
}